import { Divider, Grid, Typography } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionADLFields } from '../types/fields';
import { OperacionADL } from "../types/types";
import { ADLClienteTipo } from "../types/enum";

type SeccionADLDatosOperacionProps = {
  operacion: OperacionADL;
}

const SeccionADLDatosOperacion = ({ operacion }: SeccionADLDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>

        <Grid item xs={12} md={3}>
          <FieldView label='País' value={operacion[OperacionADLFields.NombrePais]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Unidad de Negocio' value={operacion[OperacionADLFields.UnidadNegocio]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Equipo Comercial' value={operacion[OperacionADLFields.SectorComercial]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView
            label='Fecha Solicitud'
            value={operacion[OperacionADLFields.FechaSolicitud]
              ? dateFormatter.toShortDate(operacion[OperacionADLFields.FechaSolicitud])
              : undefined}
          />
        </Grid>

        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Deudor
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12} md={4}>
          <FieldView label='Razón Social del Deudor' value={operacion[OperacionADLFields.RazonSocial]} />
        </Grid>
        <Grid item xs={12} md={8 / 3}>
          <FieldView label='Legislación' value={operacion[OperacionADLFields.DescLegislacionTipo]} />
        </Grid>
        <Grid item xs={12} md={8 / 3}>
          <FieldView label='Prospecto o Cliente' value={operacion[OperacionADLFields.DescClienteTipo]} />
        </Grid>
        {operacion[OperacionADLFields.CodVirtualCliente] === ADLClienteTipo.Cliente && (
          <Grid item xs={12} md={8 / 3}>
            <FieldView label='Nro. Cuenta' value={operacion[OperacionADLFields.NroCuenta]} />
          </Grid>
        )}

      </Grid>
    </CardActions>
  );
}

export default SeccionADLDatosOperacion;